import React from 'react';
import { Link } from 'react-router-dom';
import { isStandalone } from '../utils/platform';

// Body of the "Install the app" card on the patient settings page: the banner can
// be dismissed for 30 days, so this keeps the install steps findable.
export default function InstallAppSection() {
  if (isStandalone()) {
    return <div className="alert alert-success" role="status">Previu is installed on this device.</div>;
  }
  return (
    <div>
      <p className="notice-text">
        Add Previu to your Home Screen to open it in one tap, and to get appointment reminders as notifications.
      </p>
      <Link className="btn btn-secondary" to="/install">Show me how</Link>
    </div>
  );
}
